<div class="aside_title-section">
  <h1 class="title-dashboard">{{ 'MAINTENANCE.DUE_MAINTENANCE' | translate }}</h1>
</div>

@if (
  permissionService.checkPermissionValue({
    permission: 'READ',
    tab: 'maintenance',
  })
) {
  <div class="widget-content-height">
    @if ($maintenances()?.todo) {
      @if ($outOfDeadlinesMaintenances()?.length) {
        @for (maintenance of $outOfDeadlinesMaintenances() | slice: 0 : 5; track maintenance) {
          <maintenance-card [maintenance]="maintenance" />
        }
      }
      @if (!$outOfDeadlinesMaintenances() || $outOfDeadlinesMaintenances()?.length < 1) {
        <div class="missing-data-dashboard">
          <p>{{ 'MAINTENANCE.NO_DEADLINE_REACHED' | translate }}</p>
        </div>
      }
    } @else {
      <widget-loader />
    }
  </div>
  @if ($outOfDeadlinesMaintenances()?.length > 5) {
    <div class="data-more-icon">
      <mat-icon [routerLink]="[BUILD]" [matTooltip]="'COMMON.SEEMORE' | translate">more_horiz</mat-icon>
    </div>
  }
} @else {
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
